import videojs from 'video.js';

//TODO: Create message that shows when presentation is audio only, with no video or slide stream shown
export default class AudioOnlyPlugin extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);    
    }

    hideAudioOnlyVideo() {
            const element = this.player.tech(true).el();
            element.style.left = '0px';
            element.style.top = `0px`;
            element.style.width = `0px`;
            element.style.height = `0.01px`;
    }
}
